import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export interface ErrorsPreferenceState {
    /** When true, the Errors panel opens automatically in the detached dialog on mount. */
    autoDetach: boolean;
}

const initialState: ErrorsPreferenceState = {
    autoDetach: false
};

const errorsPreferenceSlice = createSlice({
    name: 'errorsPreference',
    initialState,
    reducers: {
        setAutoDetach: (state, action: PayloadAction<boolean>) => {
            state.autoDetach = action.payload;
        },
        toggleAutoDetach: (state) => {
            state.autoDetach = !state.autoDetach;
        }
    }
});

const errorsPreferenceConfig = {
    key: 'errorsPreference',
    storage
};

export const persistedErrorsPreferenceReducer = persistReducer(errorsPreferenceConfig, errorsPreferenceSlice.reducer);
export const { setAutoDetach, toggleAutoDetach } = errorsPreferenceSlice.actions;
